<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gPFPyP/tc-custom/9781455607631.jpg?1704485257685" alt="This image is the cover for the book Lorenzo"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lorenzo
      </h1>
      <p class="bookDescription body article font2">
        <p>Lorenzo Casso left his motherland of Italy during the turbulent years when Garibaldi was waging civil war across the land and, soon after his arrival in the United States, found himself caught up in the American Civil War. He became Ascension Parish's first Italian immigrant, settling in Donaldsonville, where he married a Louisiana Creole and founded theCasso family in Louisiana. His descendants now total almost five hundred. Pestilence, flood, crop failure, civil strife, death, destruction and disappointment-the age-old elements in man's struggle for existence-are all chronicled in this vivid and moving account of one family's life on the Louisiana frontier. Evans J. Casso writes about his Venetian grandfather with poignancy and admiration, while capturing the drama and pathos that characterized the family's rich history. His maternal ancestry, which is thoroughly French, reaches back into Louisiana's early history to such grandsires as Felix Babin, Theodule Richard, and Jean Baptiste Gaudin, a prominent sugar planter, landowner, and slave-holder in antebellum Ascension Parish.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Evans Casso
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?042b35b2